import React from "react";
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@material-ui/core";

interface Props {
  record: any;
  loading?: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const ShipFromIstDialog: React.FC<Props> = ({ record, loading = false, onClose, onConfirm }) => (
  <Dialog open={!!record} onClose={onClose} disableRestoreFocus disableBackdropClick={loading}>
    <DialogTitle>Ship from IST</DialogTitle>
    <DialogContent>
      <DialogContentText>
        Are you sure you want to ship <strong>{record?.refNo}</strong> from IST?
        <br />
        This will remove the request from Local Repairs and move it to Unshipped SVC.
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} color="default" disabled={loading}>
        No
      </Button>
      <Button
        onClick={onConfirm}
        color="primary"
        variant="contained"
        disabled={loading}
        startIcon={loading ? <CircularProgress size={14} color="inherit" /> : undefined}
      >
        {loading ? "Shipping..." : "Yes"}
      </Button>
    </DialogActions>
  </Dialog>
);

export default ShipFromIstDialog;
